import React, { Component } from 'react'
import PropTypes from 'prop-types'
import menuIcon from '../img/menu.png'
// import bgImg from '../img/bgImg.jpg'
import { Route } from 'react-router-dom'

export default class Picker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			menuShowed: false,
			keyword: props.searchKeyword
		}
	}

	handleMenu = () => {
		this.setState({
			menuShowed: !this.state.menuShowed
		});
	}

	handleChange = (e, history) => {
		this.props.onChange(e.target.value);
		let humanKeyword = e.target.value.split(' ').join("-");
		humanKeyword === "All" ? history.push("/") : history.push(humanKeyword);
	}

	onSearchChange = (e) => {
		this.setState({
			keyword: e.target.value
		});
		this.props.onSearchChange(e.target.value);
	}
  render() {
		const { options } = this.props
		const { keyword } = this.state;
    return (
      <div className="search container">
				<div className="input">
					<input className="search-field" type="text" placeholder="Search for remote jobs..." onChange={e => this.onSearchChange(e)} autoFocus />
					<Route render={({ history}) => (
					<select name="tag-filter" onChange={e => this.handleChange(e, history)} defaultValue={keyword}>
						{options.map(option => (
								<option value={option} key={option}>
									{option}
								</option>
						))}
					</select>
					)} />
				</div>
				{/* <label htmlFor="tag-filter">Filter by tag:</label> */}
				{/* <div className="tags"> */}
				{/* <Select/> */}
				<img className="menu-icon" src={menuIcon} alt="Menu" onClick={this.handleMenu}/>
				<div className={this.state.menuShowed ? "header-links show" : "header-links"}>
					<h2>About the project</h2>
					<p>This website is remote jobs aggregator, aggregating jobs from over 10 websites.</p>
					<p>Subscribe to get updates on new remote jobs and updates about the app:</p>
					<div id="mc_embed_signup">
						<form action="https://itopen.us3.list-manage.com/subscribe/post?u=a3ab4b6c8a8ace4e1f041250a&amp;id=588fe4f9bf" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
							<div id="mc_embed_signup_scroll">
								<div className="mc-field-group">
									<label htmlFor="mce-EMAIL">Email Address </label>
									<input type="email" name="EMAIL" className="required email" id="mce-EMAIL"/>
								</div>
								<div id="mce-responses" className="clear">
									<div className="response" id="mce-error-response" style={{display: 'none'}}></div>
									<div className="response" id="mce-success-response" style={{display: 'none'}}></div>
								</div>
								<div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true"><input type="text" name="b_a3ab4b6c8a8ace4e1f041250a_588fe4f9bf" tabIndex="-1" value=""/></div>
								<input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button"/>
							</div>
						</form>
					</div>
					<p>If you want to submit a job, contact me on <a href="https://twitter.com/LekovicMilos" target="_blank" rel="noopener noreferrer">Twitter</a>. </p>
					<p>Made by <a href="https://www.linkedin.com/in/miloslekovic/" target="_blank" rel="noopener noreferrer">Milos Lekovic</a></p>
					<img onClick={this.handleMenu} className="close" src="data:image/png;base64,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" alt="" />
				</div>
				{this.props.children}
      </div>
    )
  }
}

// const Select = withRouter(({ history }) => (
// 	<select name="tag-filter" onChange={e => this.handleChange(e.target.value, history)} defaultValue={this.state.keyword}>
// 		{this.props.options.map(option => (
// 			<option value={option} key={option}>
// 				{option}
// 			</option>
// 		))}
// 	</select>
// ))

Picker.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	onSearchChange: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/components/Picker.js